import HomeRoundedIcon from '@mui/icons-material/HomeRounded'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import SettingsIcon from '@mui/icons-material/Settings'

export const LkMenuItems = [
  { Icon: HomeRoundedIcon, link: '/', text: 'Главная' },
  {
    Icon: LocalShippingIcon,
    link: '/appeals',
    text: 'Обращения',
  },
  {
    Icon: LocationOnIcon,
    link: '/myaddresses',
    text: 'Мои адреса',
  },
  { Icon: SettingsIcon, link: '/settings', text: 'Настройки' },
]
